<!-- <span>{{min}},{{max}},{{minDummy}},{{maxDummy}}</span> -->

<!-- <div class="collection-collapse-block border-0" [class.open]="collapse" id="price">
    <h3 class="collapse-block-title" (click)="collapse = !collapse">price <span *ngIf="collapse ==false"
            style="    margin-left: 25px;">{{min}}-{{max}}</span></h3>

    <div class="collection-collapse-block-content">
        <div class="collection-brand-filter">
            <div class="mt-2">
                <ngx-slider [(value)]="min" [(highValue)]="max" [options]="options"
                    (userChangeEnd)="appliedFilter($event)" *ngIf="isBrowser">
                </ngx-slider>

            </div>
        </div>
    </div>

    <div class="form-group row collection-collapse-block-content" style="padding-top: 25px;">
        <div class="col-md-5 pb-2">
            <input type="number" [(ngModel)]="min" (input)="formatNumber($event)" 
            name="minValue1" *ngIf="isBrowser" class="form-control input-number"
            [min]="0" [max]="max">
     

        </div>
        <div class="col-md-2">
            <h6 class="text-center mt-2">to</h6>

        </div>

        <div class="col-md-5 pb-2">
            <input type="number" [(ngModel)]="max" name="maxValue1" *ngIf="isBrowser" class="form-control input-number"
                [min]="min" [max]="2000">
        </div>

        <div class="d-flex justify-content-center">
            <button class="btn btn-solid btn-sm" (click)="changeprice($event)" id="nbtn">Apply</button>
        </div>


    </div>
</div> -->




<div class="collection-collapse-block border-0" [class.open]="collapse" id="price">
    <h3 class="collapse-block-title" (click)="collapse = !collapse">price <span *ngIf="collapse ==false"
            style="    margin-left: 25px;">{{min}}-{{max}}</span></h3>

    <div class="filter-section">
        <h4>Price</h4>
        <ul class="filter-list">
            <li><input type="checkbox"> ₹ 0 TO ₹ 499 </li>
            <li><input type="checkbox"> ₹ 500 TO ₹ 999 </li>
            <li><input type="checkbox"> ₹ 1000 TO ₹ 1499 </li>
            <li><input type="checkbox"> ₹ 1500 AND ABOVE </li>
        </ul>
    </div>
</div>